import { useRef, useEffect, useState } from 'react';

const credentials = [
  { icon: 'ri-award-fill', label: 'Licensed Real Estate Broker', sub: 'State of Georgia' },
  { icon: 'ri-building-2-fill', label: 'Residential & Commercial', sub: 'Full Service Expertise' },
  { icon: 'ri-map-pin-2-fill', label: 'Local Market Expert', sub: 'Duluth · Suwanee · Atlanta' },
  { icon: 'ri-graduation-cap-fill', label: 'School District Specialist', sub: 'Gwinnett County Expert' },
];

export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-24 bg-[#F8F6F1]">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Image Column */}
        <div className="relative">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://static.readdy.ai/image/7d3e6a33ff3ec6867c6d17500d87965d/0b24034e5dfeabdbe353d0d481955d98.webp"
              alt="Shawn Kim - Atlanta Realtor 김산 부동산"
              className="w-full h-[500px] object-cover object-top"
            />
          </div>
          {/* Experience badge */}
          <div className="absolute -bottom-6 -right-6 bg-[#B8963E] text-white rounded-lg p-5 text-center">
            <div className="font-['Playfair_Display'] text-4xl font-bold leading-none">30+</div>
            <div className="text-xs font-semibold mt-1 tracking-wide">YEARS<br/>EXPERIENCE</div>
          </div>
        </div>

        {/* Text Column */}
        <div>
          <p className="text-[#B8963E] text-xs font-bold tracking-widest uppercase mb-3">About Shawn Kim · 김산 소개</p>
          <h2 className="font-['Playfair_Display'] text-[#1A1A1A] text-3xl lg:text-4xl font-bold leading-tight mb-6">
            Your Trusted Atlanta,<br />Duluth &amp; Suwanee Realtor
          </h2>

          <div className="space-y-4 text-[#444] text-sm leading-relaxed mb-6">
            <p>
              With over <strong>30 years of experience</strong>, Shawn Kim (김산) is one of the most respected real estate brokers in the Greater Atlanta area. Specializing in residential home sales, commercial real estate, and investment properties, Shawn helps buyers, sellers, and investors navigate the dynamic Atlanta market with confidence.
            </p>
            <p>
              As a recognized local expert in <strong>Duluth and Suwanee</strong>, Shawn has an in-depth understanding of school districts, neighborhood trends, and property values — giving clients a decisive advantage in every transaction.
            </p>
            <p className="text-[#666] italic border-l-2 border-[#B8963E] pl-4">
              김산 부동산 Shawn Kim은 30년 이상의 경험을 가진 Atlanta 지역 부동산 브로커입니다. 주택 매매, 상업용 부동산, 투자용 부동산 컨설팅을 전문으로 하며, 특히 둘루스와 스와니 지역의 학군과 시장 동향에 정통합니다. 고객님의 소중한 자산을 안전하게 관리하고 최적의 부동산 거래를 도와드립니다.
            </p>
          </div>

          {/* Credentials Grid */}
          <div className="grid grid-cols-2 gap-4 mt-8">
            {credentials.map((item) => (
              <div key={item.label} className="flex items-start gap-3 bg-white rounded-lg p-4">
                <div className="w-9 h-9 flex items-center justify-center bg-[#B8963E]/10 rounded-md flex-shrink-0">
                  <i className={`${item.icon} text-[#B8963E] text-lg`}></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-[#1A1A1A]">{item.label}</div>
                  <div className="text-xs text-[#888] mt-0.5">{item.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-center gap-4">
            <a
              href="tel:4049340670"
              className="bg-[#1A1A1A] hover:bg-[#333] text-white px-6 py-3 rounded-md text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Call Shawn Kim
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="border border-[#B8963E] text-[#B8963E] hover:bg-[#B8963E] hover:text-white px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
